import {
  ReadingCacheType,
  useReadAPIWithServices,
} from 'api/useAPIWithServices';
import { useAppServices } from 'container/depContext';

export const useGetProcessDraft = (draftId: string) => {
  const { getProcessRepo } = useAppServices();
  const { getProcessDraft } = getProcessRepo();

  const { data: draft, isLoading: isDraftLoading } = useReadAPIWithServices(
    [getProcessDraft.name, draftId],
    () => getProcessDraft(draftId),
    { cacheType: ReadingCacheType.ExecutionDraftDependency }
  );

  return {
    draft,
    isDraftLoading,
  };
};
